import { LineType } from '@insurgrid/common';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { owlClient } from '../../apiUtils/client';
import { QueryKey } from '../../types';
import { mergeCarrierLists } from './carrierLines';

function useLineCarrierList(lineType: LineType, enabled: boolean) {
  return useQuery(
    [QueryKey.CarrierList, lineType],
    () => owlClient.carrier.fetchList({ query: { insuranceLine: lineType } }),
    { enabled, select: (data) => data.data },
  );
}

export function useMergedCarrierList(enabled: boolean) {
  const personal = useLineCarrierList(LineType.Personal, enabled);
  const commercial = useLineCarrierList(LineType.Commercial, enabled);

  const carrierList = useMemo(
    () =>
      personal.data && commercial.data
        ? mergeCarrierLists(personal.data, commercial.data)
        : undefined,
    [personal.data, commercial.data],
  );

  return {
    carrierList,
    carrierListLoading: enabled && (personal.isLoading || commercial.isLoading),
  };
}
